import logger from '@/lib/edge-logger';
import { genSalt, hash } from 'bcryptjs';
import { AES, enc } from 'crypto-js';

// 从环境变量获取加密密钥，如果不存在则抛出错误
const getEncryptionKey = (key: string): string => {
    // 优先使用环境变量中的密钥
    const envKey = process.env.ENCRYPTION_SECRET_KEY;
    if (envKey) {
        return envKey.padEnd(32, '0').slice(0, 32);
    }
    // 开发环境使用传入的 key（需要确保长度足够）
    if (key.length < 8) {
        throw new Error('加密密钥长度必须至少为8个字符');
    }
    return key.padEnd(32, '0').slice(0, 32);
};

export async function verifyPassword(password: string, storedPassword: string, salt?: string): Promise<boolean> {
    try {
        // 如果是明文密码直接比较
        if (!salt) {
            return password === storedPassword;
        }
        // 如果是加密密码，使用salt重新加密后比较
        const hashedInput = await hashWithSalt(password, salt);
        return hashedInput === storedPassword;
    } catch (error) {
        // 记录错误但不暴露详情
        logger.error('密码验证失败');
        return false;
    }
}

export async function generateSalt(): Promise<string> {
    return await genSalt(10);
}

export async function hashWithSalt(password: string, salt: string): Promise<string> {
    return await hash(password, salt);
}

export async function encryptPassword(password: string): Promise<{ encryptedPassword: string; salt: string }> {
    const salt = await generateSalt();
    const encryptedPassword = await hashWithSalt(password, salt);
    return { encryptedPassword, salt };
}

export function encryptWithAES(data: string, key: string): string {
    const secureKey = getEncryptionKey(key);
    return AES.encrypt(data, secureKey).toString();
}

export function decryptWithAES(encryptedData: string, key: string): string {
    const secureKey = getEncryptionKey(key);
    return AES.decrypt(encryptedData, secureKey).toString(enc.Utf8);
}